import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.StandaloneSearchFields', {
    requestorFieldTitle: 'Requester',
    requestorPlaceholder: 'Select requester',
    standaloneRequestNameFieldTitle: 'Request name',
    standaloneRequestNamePlaceholder: 'Enter request name',
    standaloneRequestDescriptionFieldTitle: 'Request description',
    standaloneRequestDescriptionPlaceholder: 'Enter request description',
});
